import axios from "axios";
import Router from "@/router";

//AuthService
export default {
	token: "",
	user: null,
	getUserPromise: null,
	queuedRefresh: null,

	//Gets the logged in user, pass refresh = true to ask the server for latest user
	getUser(refresh) {
		if (!this.getUserPromise || refresh || this.queuedRefresh) {
			this.queuedRefresh = null;
			this.getUserPromise = new Promise((resolve, reject) => {
				axios
					.get("/v3/auth")
					.then(resp => {
						var user = resp.data.data;
						if (user) {
							resolve(user);
						} else {
							reject(resp.data);
						}
					})
					.catch(err => {
						reject(err);
					});
			});
		}
		return this.getUserPromise;
	},

	queueRefresh() {
		this.queuedRefresh = true;
	},

	//clearState clears out the auth information
	clearState() {
		//TODO clear cookie just to be sure
		this.getUserPromise = null;
		this.token = "";
		axios.defaults.headers.common["X-Auth-Token"] = this.token;
	},

	//Logs the user in and set up auth for future requests
	login(username, password) {
		var _this = this;
		return new Promise((resolve, reject) => {
			axios
				.post("/v3/auth", {
					email: username,
					password: password
				})
				.then(function (data) {
					//We don't really have to store the token, we'll use the "oscar" cookie until we see reasons otherwise
					_this.token = data.data.data;
					//It seems like any requests that happen within this resolve do not carry the cookie so we'll set this here. Cookie will be used on page refresh
					axios.defaults.headers.common["X-Auth-Token"] = _this.token;
					resolve(data);
				})
				.catch(function (err, er) {
					reject(err);
				});
		});
	},

	// Logs the user out and navigates to sign-in page
	logout() {
		var _this = this;
		return new Promise((resolve, reject) => {
			axios.get("/v3/logout").then(function () {
				_this.clearState();
				Router.push({
					path: "/"
				});
			});
		});
	},

	acceptEula() {
		this.queueRefresh();
		return axios.post("/v3/accept_eula");
	},

	acceptTerms() {
		this.queueRefresh();
		return axios.post("/v3/accept_terms");
	},

	getTimeout() {
		return axios.get("/v3/timeout");
	},

	resetPassword(email) {
		return axios.post("/v3/resetPassEmail", {
			email: email
		});
	},

	setNewPassword(token, password) {
		return axios.post("/v3/resetPass", {
			token: token,
			password: password
		});
	}
};



// WEBPACK FOOTER //
// ./src/services/AuthService.js